/**
 * ProGrade Popup Handler
 * Handles the display and interaction of the ProGrade welcome popup
 */
(function() {
  'use strict';

  class ProgradePopup {
    constructor(element) {
      this.element = element;
      this.options = JSON.parse(element.getAttribute('data-popup-settings') || '{}');
      this.isOpen = false;

      // Show popup after delay
      setTimeout(() => {
        this._openPopup();
      }, (this.options.apparitionDelay || 0) * 1000);

      this._attachListeners();
    }

    _attachListeners() {
      // Close button listener
      const closeButtons = this.element.querySelectorAll('[data-action="close-popup"]');
      closeButtons.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this._closePopup();
        });
      });

      // Click outside to close
      this.element.addEventListener('click', (e) => {
        if (e.target === this.element || e.target.classList.contains('modal__dialog')) {
          this._closePopup();
        }
      });

      // Escape key to close
      document.addEventListener('keyup', (e) => {
        if (e.key === 'Escape' && this.isOpen) {
          this._closePopup();
        }
      });
    }

    _openPopup() {
      // Don't open if another popup is open
      if (window.theme && (window.theme.isExitPopupOpen || window.theme.isNewsletterPopupOpen)) {
        console.log('ProGrade popup blocked by another popup');
        return;
      }

      console.log('Opening ProGrade popup');
      this.element.setAttribute('aria-hidden', 'false');
      this.isOpen = true;
    }

    _closePopup() {
      this.element.setAttribute('aria-hidden', 'true');
      this.isOpen = false;
    }
  }

  // Store popup instances for theme editor access
  window.progradePopups = {};

  // Initialize when DOM is ready
  function init() {
    const progradePopups = document.querySelectorAll('[data-popup-type="prograde"]');
    console.log('ProGrade popup init, found:', progradePopups.length, 'popups');
    progradePopups.forEach(popup => {
      const instance = new ProgradePopup(popup);
      window.progradePopups[popup.closest('[data-shopify-editor-block]')?.getAttribute('data-shopify-editor-block') || 'default'] = instance;
    });
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Listen for Shopify theme editor events
  document.addEventListener('shopify:block:select', function(event) {
    const popup = event.target.querySelector('[data-popup-type="prograde"]');
    if (popup) {
      popup.setAttribute('aria-hidden', 'false');
    }
  });

  document.addEventListener('shopify:block:deselect', function(event) {
    const popup = event.target.querySelector('[data-popup-type="prograde"]');
    if (popup) {
      popup.setAttribute('aria-hidden', 'true');
    }
  });
})();
